<!-- 平台建单:淘天 -->
<template>
  <div class="PlatformOrderCreation">
    <el-collapse v-model="activeName">
      <div class="title">
        <img
          src="@/assets/images/baseinfo.png"
          alt=""
        /><span class="title-text">淘天建单</span>
      </div>
      <avue-form
        ref="formData"
        v-model="formData"
        :option="option"
      >
        <template slot="uploadImg">
          <upload-file
            ref="uploadAll"
            v-model="formData.uploadImg"
            title="图片"
            :limit="6"
            uploadTips
            :fileTypeList="['jpg', 'png', 'jpeg']"
          />
        </template>
      </avue-form>
      <div class="create-order">
        <el-button
          class="create-btn"
          type="primary"
          size="small"
          :loading="btnLoading"
          @click="handleCreate"
        >{{ $lang("创建工单") }}</el-button>
      </div>
      <el-collapse-item name="2">
        <span
          class="order-title"
          slot="title"
        >
          {{ $lang("工单创建") }}
          <span class="total-view">({{ (createList || []).length || 0 }})</span>
        </span>
        <el-table
          :data="createList"
          height="250"
          border
          v-loading="createLoading"
        >
          <template v-for="item in createOption">
            <el-table-column
              align="center"
              :prop="item.prop"
              :label="$lang(item.label)"
              :key="item.prop"
              :width="item.width"
            >
            </el-table-column>
          </template>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { platformOrderApi } from '../pool';
import { RULES } from '@/common/utils/validators';
import debounce from 'lodash/debounce';

export default {
  name: 'PlatformOrderCreationTaoTian',
  props: {
    customerInfo: {
      type: Object,
      default: () => { }
    }
  },
  watch: {
    customerInfo: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      activeName: [],
      sessionId: '',
      createList: [], // 工单创建列表
      formData: { uploadImg: [] },
      showPropList: [],
      btnLoading: false,
      createLoading: false
    };
  },
  methods: {
    // 初始化
    init: debounce(function () {
      this.sessionId = this.customerInfo.sessionId || '';
      if (!this.sessionId) return;
      this.activeName = [];
      this.taskList = [];
      this.createList = [];
      this.selectCreatedList = [];
      this.createValue = '';
      this.getTaskList();
    }, 500),
    // 获取
    async getTaskList() {
      this.createLoading = true;
      const { data } = await platformOrderApi
        .getTaoTianWorkOrder(this.sessionId)
        .catch(() => {
          this.createLoading = false;
        });
      this.createLoading = false;
      this.createList = data || [];
      this.createList?.length && this.activeName.push('2');
    },
    // 创建工单
    async handleCreate() {
      this.$refs.formData.validate(async (val) => {
        if (val) {
          this.btnLoading = true;
          const { serviceCode, serviceName, description } = this.formData;
          const params = {
            sessionId: this.sessionId,
            serviceCode,
            serviceName,
            description
          };
          // showProp:需要传给平台的参数 ，多余的不传
          Object.keys(this.formData).forEach((key) => {
            if (this.showPropList.includes(key)) {
              params[key] = this.formData[key];
              key === 'uploadImg' &&
                params[key] &&
                (params[key] = params[key].map((o) => o.path)?.join(',') || '');
            }
          });
          const { code, msg } = await platformOrderApi
            .pushTaoTianWorkOrder(params)
            .catch(() => {
              this.btnLoading = false;
            });
          this.btnLoading = false;
          if (code === 1) {
            this.$message.success(msg);
            this.clearForm();
            this.getTaskList();
          } else {
            this.$message.error(msg);
          }
        }
      });
    },
    clearForm() {
      this.$refs.formData?.resetForm();
      this.formData = { uploadImg: [] };
      this.showPropList = [];
    }
  },
  computed: {
    // 商家任务单
    option() {
      const that = this;
      return {
        menuBtn: false,
        column: [
          {
            label: '工单类型',
            prop: 'serviceCode',
            type: 'select',
            clearable: false,
            dicData: [
              { label: '催派', value: 'URGE_DELIVERY', showProp: [] },
              { label: '催揽收', value: 'URGE_COLLECTION', showProp: [] },
              { label: '丢失', value: 'GOODS_LOSS', showProp: ['uploadImg'] },
              { label: '破损', value: 'GOODS_DAMAGED', showProp: ['uploadImg'] },
              { label: '时效内催促', value: 'DELIVERY_URGENCY', showProp: ['uploadImg'] },
              {
                label: '签收未收到',
                value: 'SIGNED_BUT_NOT_RECEIVED',
                showProp: ['uploadImg']
              },
              {
                label: '超时未派送',
                value: 'OVERDUE_URGE_ESCALATION',
                showProp: ['uploadImg']
              },
              {
                label: '异常物流轨迹',
                value: 'ABNORMAL_LOGISTICS_TRACK',
                showProp: ['uploadImg']
              },
              {
                label: '运输超时/停滞',
                value: 'TRANSPORTATION_TIMEOUT',
                showProp: ['uploadImg']
              },
              {
                label: '修改联系人电话号码',
                value: 'MODIFY_RECEIVER_PHONE',
                showProp: ['phone']
              },
              {
                label: '指定派件信息(时间/方式)',
                value: 'SELECTED_DELIVERY_INFO',
                showProp: [
                  'deliveryTime',
                  'deliveryWayCode',
                  'deliveryWayName',
                  'collectionPlace'
                ]
              }
            ],
            rules: [RULES.required],
            change: ({ valueObj }) => {
              that.formData.serviceName = valueObj.label || '';
              that.showPropList = valueObj.showProp || [];
            }
          },
          {
            label: '电话号码',
            prop: 'phone',
            rules: [
              RULES.required,
              {
                validator: (rule, value, callback) => {
                  const regExp1 = /^1[3-9]\d{9}$/;
                  const regExp2 = /^(0\d{2,3})?-?\d{7,8}$/;
                  const regExp3 = /^(\(0\d{2,3}\))?-?\d{7,8}$/;
                  const regExp4 = /^(400-\d{3}-\d{4}|400\d{7})$/;
                  const regExp5 = /^95\d{3,4}$/;
                  if (
                    value &&
                    !(
                      regExp1.test(value) ||
                      regExp2.test(value) ||
                      regExp3.test(value) ||
                      regExp4.test(value) ||
                      regExp5.test(value)
                    )
                  ) {
                    callback(new Error(this.$lang('请输入正确的电话号码')));
                  } else {
                    callback();
                  }
                }
              }
            ],
            display: that.showPropList.includes('phone')
          },
          {
            label: '派送时间',
            prop: 'deliveryTime',
            type: 'datetime',
            display: that.showPropList.includes('deliveryTime'),
            rules: that.formData.deliveryWayCode ? [] : [RULES.required]
          },
          {
            label: '派送方式',
            prop: 'deliveryWayCode',
            type: 'select',
            dicData: [
              { label: '放自提柜', value: 'TO_CABINET' },
              { label: '放代收点', value: 'TO_CUSTOMER_LOCATION' },
              { label: '放门卫', value: 'TO_GUARD' }
            ],
            display: that.showPropList.includes('deliveryWayCode'),
            change: ({ valueObj }) => {
              that.formData.deliveryWayName = valueObj.label || '';
              that.formData.collectionPlace = '';
            },
            rules: that.formData.deliveryTime ? [] : [RULES.required]
          },
          {
            label: '指定派送具体地点',
            prop: 'collectionPlace',
            type: 'textarea',
            span: 24,
            maxlength: 200, // 派送方式有值时 需要填写地址
            display:
              that.showPropList.includes('collectionPlace') &&
              !!that.formData.deliveryWayCode,
            rules: [RULES.required]
          },
          {
            label: '问题描述',
            prop: 'description',
            type: 'textarea',
            maxlength: 500,
            showWordLimit: true,
            span: 24
          },
          {
            label: '',
            prop: 'uploadImg',
            formslot: true,
            span: 24,
            display: that.showPropList.includes('uploadImg')
          }
        ]
      };
    },
    // 工单创建
    createOption() {
      return [
        {
          label: '工单类型',
          prop: 'serviceName'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          width: 160
        },
        {
          label: '状态',
          prop: 'successName'
        },
        {
          label: '错误信息',
          prop: 'errorMsg'
        },
        {
          label: '淘天服务跟踪单号',
          prop: 'serviceOrderCode',
          width: 190
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.PlatformOrderCreation {
  padding: 0px 10px;
  ::v-deep .el-collapse-item__content {
    padding: 10px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  .create-order {
    margin: 15px 0px 5px 0px;
    text-align: right;
    .create-btn {
      display: inline-block;
      margin-left: 10px;
    }
  }
  .title {
    font-weight: bold;
    padding-left: 10px;
    margin-bottom: 10px;
    img {
      vertical-align: middle;
      margin-right: 5px;
      width: 16px;
      height: 19px;
      margin-bottom: 3px;
    }
  }
  .title-text {
    position: relative;
  }
  .title-text::after {
    content: '*';
    display: block;
    position: absolute;
    color: #e60012;
    top: -2px;
    right: -7px;
  }
  ::v-deep .el-collapse-item {
    border-radius: 10px;
    overflow: hidden;
  }
  ::v-deep .el-collapse-item__header::before {
    display: none;
  }
  ::v-deep .el-collapse-item__header {
    font-weight: bold;
  }
}
::v-deep .uploadTips {
  top: 33px;
}
::v-deep .avue-group {
  border: none !important;
}
::v-deep .avue-form__group {
  padding: 0;
}
</style>
